<template>
  <div class="date-wrapper">
    <div>{{title}}</div>
    <div class="datePickerDate" >
      <div class="datePickerIcon">
        <datepicker
            :value="value"
            :language="sk"
            minimumView="month"
            maximumView="month"
            :id="id"
            @selected="handleSelect"
        />
      </div>
      <div v-if="value" style="font-weight: 900;">{{value.toLocaleString('sk-SK', {month: 'long'})}} {{value.getFullYear()}}</div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {sk} from 'vuejs-datepicker/dist/locale'

export default {
  name: "DatePicker",
  components: {
    Datepicker
  },
  props: {
    title: String,
    dataRef: String,
    initValue: Date,
    id: String
  },
  data() {
    return {
      value: this.initValue,
      sk
    }
  },
  mounted() {
    const input = document.getElementById(this.id);

    const inputParent = input.parentNode;
    inputParent.style.display = "flex";

    this.label = document.createElement("label");

    const id = `input-${this.id}`;
    input.setAttribute("id", id);

    this.label.setAttribute("for", id);
    this.label.style.color = "#0A1953";

    input.style.display = "none";

    this.icon = document.createElement("img");
    this.icon.setAttribute("src", require("../assets/calendar.svg"));
    this.label.appendChild(this.icon);
    this.label.classList.add("label");
    inputParent.append(this.label);
  },
  methods: {
    handleSelect(e) {
      this.value = e;

      this.$emit("change", {dataRef: this.dataRef, value: e});
    }
  }
}
</script>
<style lang="scss">

</style>